import React from 'react'

export default () => (
  <section id="message">
    <div className="section_contents">
        <p>2007年に設立以降、LYZONはついに社員数100名を突破しました。<br />現在LYZONは、これまでに培ったノウハウを武器に、<br className="d-none d-lg-inline" />さらなる飛躍を目指す重要な時期に突入しております。<br />私たちと一緒に新しいことに挑戦してくれる仲間を歓迎します。</p>
    </div>
  </section>
)


// WEBPACK FOOTER //
// ./src/Home/Message.js